import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const BannerContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${({ theme }) => theme.UI.Spacing.Space4}px;
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
  background-color: #e6ebf2;
  padding: ${({ theme }) => theme.UI.SpacingPx.Space4}
    ${({ theme }) => theme.UI.SpacingPx.Space6};
  padding-left: calc(
    var(--safe-area-inset-left) + ${({ theme }) => theme.UI.Spacing.Space6}px
  );
  padding-right: calc(
    var(--safe-area-inset-right) + ${({ theme }) => theme.UI.Spacing.Space6}px
  );

  @media ${breakpoints.s} {
    padding-left: calc(
      var(--safe-area-inset-left) + ${({ theme }) => theme.UI.Spacing.Space6}px
    );
    padding-right: calc(
      var(--safe-area-inset-right) + ${({ theme }) => theme.UI.Spacing.Space6}px
    );
  }

  @media ${breakpoints.m} {
    padding-left: calc(
      var(--safe-area-inset-left) + ${({ theme }) => theme.UI.Spacing.Space12}px
    );
    padding-right: calc(
      var(--safe-area-inset-right) +
        ${({ theme }) => theme.UI.Spacing.Space12}px
    );
  }

  @media ${breakpoints.l} {
    padding-left: calc(
      var(--safe-area-inset-left) + ${({ theme }) => theme.UI.Spacing.Space20}px
    );
    padding-right: calc(
      var(--safe-area-inset-right) +
        ${({ theme }) => theme.UI.Spacing.Space20}px
    );
  }

  button {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    color: inherit;
    font: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export { BannerContainer }
